import React from 'react';
import CardData from '../../../../../../../utils/CardData';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, OutlinedInput } from '@material-ui/core';
import { useCustomStyles } from "../../../../utils";
import { WidgetProps } from '../../../../../../widgetOverlay/widgetInteractionItem/WidgetProps';

type IframeContentTypeProps = {
	widgetTemplate: WidgetProps.WidgetTemplate;
	handleIframeUrlChange: (_text: string) => void;
};

const Iframe = ({
	widgetTemplate: {
		settings: { url } = { url: '' },
	},
	handleIframeUrlChange,
}: IframeContentTypeProps) => {
	const { t: translator } = useTranslation();
	const classes = useCustomStyles();

	return (
		<CardData title={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_IFRAME')}>
			<FormControlLabel
				className={'scenario-chart__control'}
				control={<OutlinedInput className={classes.input} value={url ?? ''} placeholder="https//qbrick.com" />}
				label={translator('Iframe URL')}
				onChange={(event: any) => {
					handleIframeUrlChange(event.target.value);
				}}
				labelPlacement="start"
				style={{
					paddingBottom: '30px',
				}}
			/>
		</CardData>
	);
};

export default Iframe;
